'use client';

import { RESPONSIVE_MARGIN } from '@/functions/createTheme';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import type React from 'react';

type Props = {
  title: string;
};

export const PageTitle: React.FC<Props> = ({ title }) => {
  const theme = useTheme();
  return (
    <Box sx={{ my: RESPONSIVE_MARGIN }}>
      <Typography
        component="h1"
        variant="h5"
        fontWeight={theme.typography.fontWeightBold}
        sx={{
          fontSize: {
            xs: theme.typography.h6.fontSize,
            sm: theme.typography.h5.fontSize
          }
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};
